const finiteNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

const nested = (value, path) => path.reduce(
  (current, key) => (current && current[key] !== undefined ? current[key] : null),
  value,
);

const normalizeProbability = (value) => {
  const number = finiteNumber(value);
  if (number === null || number < 0) return null;
  return number <= 1 ? number * 100 : number;
};

export const normalizeTrendAnalyserInput = (payload) => {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    throw new Error('The selected file must contain one JSON object.');
  }

  const probabilities = {};
  if (Array.isArray(payload.trend_probabilities)) {
    payload.trend_probabilities.forEach((item) => {
      if (item && item.direction) {
        probabilities[String(item.direction).toLowerCase()] = normalizeProbability(item.probability);
      }
    });
  }

  const sourceReferences = Array.isArray(payload.sources) ? payload.sources.filter(Boolean) : [];
  const observationTime = payload.observation_time || payload.observed_at || null;
  const qualityFlags = ['LEGACY_INPUT_UNVERIFIED'];
  if (!observationTime) qualityFlags.push('MISSING_OBSERVATION_TIME');
  if (sourceReferences.length === 0) qualityFlags.push('MISSING_SOURCE_PROVENANCE');

  return {
    instrument: payload.index || null,
    tradingDate: payload.date || null,
    observationTime,
    sourceReferences,
    qualityFlags,
    market: {
      niftyClose: finiteNumber(payload.nifty_close),
      giftNifty: finiteNumber(payload.gift_nifty),
      vix: finiteNumber(payload.vix),
      rsi: finiteNumber(nested(payload, ['technical_indicators', 'rsi'])),
      support: finiteNumber(nested(payload, ['technical_indicators', 'support'])),
      resistance: finiteNumber(nested(payload, ['technical_indicators', 'resistance'])),
      callStrike: finiteNumber(nested(payload, ['oi_data', 'call_oi', 'strike'])),
      callOi: finiteNumber(nested(payload, ['oi_data', 'call_oi', 'oi'])),
      putStrike: finiteNumber(nested(payload, ['oi_data', 'put_oi', 'strike'])),
      putOi: finiteNumber(nested(payload, ['oi_data', 'put_oi', 'oi'])),
      pcr: finiteNumber(nested(payload, ['oi_data', 'pcr'])),
      fiiNet: finiteNumber(nested(payload, ['fii_dii', 'fii_net'])),
      diiNet: finiteNumber(nested(payload, ['fii_dii', 'dii_net'])),
      sp500Change: finiteNumber(nested(payload, ['global_context', 'sp500_change'])),
      usdInr: finiteNumber(nested(payload, ['global_context', 'usd_inr'])),
      sentiment: typeof payload.news_sentiment === 'string' ? payload.news_sentiment : null,
    },
    probabilities: {
      bullish: probabilities.bullish ?? null,
      sideways: probabilities.sideways ?? null,
      bearish: probabilities.bearish ?? null,
    },
  };
};

export const hasDirectionalProbabilities = (report) => (
  report && Object.values(report.probabilities).some((value) => value !== null)
);
